module.exports = __webpack_public_path__ + "img/pub2.60f985e3.png";